import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import AddIcon from '@atlaskit/icon/core/add';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { ButtonMenuItem } from '@atlaskit/side-nav-items/button-menu-item';

type CreateContentMenuItemProps = {
	onClick: () => void;
	href?: string;
};

const addIcon = <AddIcon label="" color="currentColor" size="small" />;

export const CreateContentMenuItem = ({ onClick, href }: CreateContentMenuItemProps) => {
	if (href) {
		return (
			<LinkMenuItem
				onClick={onClick}
				elemBefore={addIcon}
				href={href}
				testId="tree-create-content-button"
			>
				<FormattedMessage {...i18n.create} />
			</LinkMenuItem>
		);
	}

	return (
		<ButtonMenuItem onClick={onClick} elemBefore={addIcon} testId="tree-create-content-button">
			<FormattedMessage {...i18n.create} />
		</ButtonMenuItem>
	);
};

const i18n = defineMessages({
	create: {
		id: 'create-blank-fabric-page.create-content-menu-item.create',
		description:
			'Label for a button that creates content in the space the user is currently viewing',
		defaultMessage: 'Create',
	},
});
